function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 2.99994C9.73478 2.99994 9.48043 3.1053 9.29289 3.29283C9.10536 3.48037 9 3.73472 9 3.99994V4.99994H15V3.99994C15 3.73472 14.8946 3.48037 14.7071 3.29283C14.5196 3.1053 14.2652 2.99994 14 2.99994H10ZM17 4.99994V3.99994C17 3.20429 16.6839 2.44123 16.1213 1.87862C15.5587 1.31601 14.7956 0.999939 14 0.999939H10C9.20435 0.999939 8.44129 1.31601 7.87868 1.87862C7.31607 2.44123 7 3.20429 7 3.99994V4.99994H5L4.98884 5H3C2.44772 5 2 5.44772 2 6C2 6.55228 2.44772 7 3 7H4V19.9999C4 20.7956 4.31607 21.5586 4.87868 22.1213C5.44129 22.6839 6.20435 22.9999 7 22.9999H17C17.7957 22.9999 18.5587 22.6839 19.1213 22.1213C19.6839 21.5587 20 20.7956 20 19.9999V7H21C21.5523 7 22 6.55228 22 6C22 5.44772 21.5523 5 21 5H19.0112L19 4.99994H17Z"
});

function SvgTrashFilled(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    className: "feather feather-trash-filled",
    ref: svgRef
  }, props), _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFilled);
export default __webpack_public_path__ + "static/media/trash-filled.5c8e9c13.svg";
export { ForwardRef as ReactComponent };